import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AppStore } from '@src/app-store';

@Component({
  imports: [],
  selector: 'app-header',
  templateUrl: './app-header.html',
  styleUrls: ['./app-header.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppHeader {
  readonly store = inject(AppStore);
}
